import { Typography, LazyImage } from '@frontend/design_system'
import rightArrow from 'assets/icons/blue700/blue700_rightArrow_16x16.webp'
import warningIconSrc from 'assets/icons/yellow700/yellow700_warning_20x20.webp'
import styles from './styles.module.scss'
import { NAVIGATION_ITEMS } from '../../constants'
import { joinClasses } from 'utils/joinClasses'
import { useNavigate, useParams } from 'react-router-dom'
import { termsSectionsSelector } from 'redux/terms/selectors'
import { useSelector } from 'react-redux'

interface INavigationProps {
  current: string
}

export const Navigation = ({ current }: INavigationProps) => {
  const navigate = useNavigate()
  const terms = useSelector(termsSectionsSelector)
  const { companyId } = useParams()

  return (
    <ul className={styles.navigation}>
      {NAVIGATION_ITEMS.map(({ url, label, id }) => {
        const goTo = () => {
          navigate(`..${url}${companyId ? `/${companyId}` : ''}`)
        }

        return (
          <Typography
            key={url}
            name="body2WMedium"
            Tag="li"
            className={joinClasses(styles.item, [
              styles.active,
              current === url,
            ])}
            onClick={goTo}
          >
            {label}
            <div className={styles.icons}>
              {terms.find(
                (term) => term.termTypeId === id && !term.isFilled
              ) ? (
                <LazyImage
                  minWidth={20}
                  width={20}
                  height={20}
                  minHeight={20}
                  src={warningIconSrc}
                  isPriority
                />
              ) : null}

              <LazyImage
                src={rightArrow}
                minWidth={16}
                height={16}
                isPriority
                className={styles.arrow}
              />
            </div>
          </Typography>
        )
      })}
    </ul>
  )
}
